import type { FC, HTMLProps, ReactNode } from "react";

import type { Spacing } from "@aviary/types/spacing";

import * as styles from "./BoxSection.styles";

interface Props extends HTMLProps<HTMLDivElement> {
  /**
   * Removes all padding
   *
   * @default false
   */
  isPaddingless?: boolean;
  /**
   * A reduced padding (0.75rem 2rem) section for elements that are spaced closer
   *
   * @default false
   */
  isReducedPadding?: boolean;
  /**
   * Customize the spacing (padding) of the boxSection
   *
   * @default normal
   */
  padding?: Spacing;
  /**
   * Children to be rendered as the BoxSection content
   *
   * @default undefined
   */
  children?: ReactNode;
}

const BoxSection: FC<Props> = ({ isPaddingless, isReducedPadding, padding, children, ...rest }) => {
  const css = [
    styles.boxSection,
    styles.padding[padding],
    isPaddingless && styles.paddingless,
    isReducedPadding && styles.reducedPadding,
  ];
  return (
    <div css={css} {...rest}>
      {children}
    </div>
  );
};

BoxSection.defaultProps = {
  padding: "normal",
};

export { BoxSection };
